import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CandidateListComponent } from "./main-content/candidates/candidate-list/candidate-list.component";
import { ProcessesComponent } from "./main-content/processes/processes.component";
import { MainContentComponent } from './main-content/main-content.component';
import { PanelMemberListComponent } from './main-content/panel-member/panel-member-list/panel-member-list.component';
import { PanelAssigningComponent } from './main-content/processes/panel-assigning/panel-assigning.component';
import { CandidateReportComponent } from './main-content/statuses/candidate-report/candidate-report.component';
import { LandingComponent } from './main-content/landing/landing.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';


export const authRoutes = ['candidates', 'processes', 'panel-member', 'live-statuses', 'dashboard'];

const routes: Routes = [
  {
    path: "login/auth/uus",
    component: LandingComponent
  },
  {
    path: "candidates",
    component: CandidateListComponent,
  },
  {
    path: "processes",
    component: ProcessesComponent
  },
  {
    path: "panel-member",
    component: PanelMemberListComponent
  },
  {
    path: "live-statuses",
    component: CandidateReportComponent
  },
  {
    path: "dashboard",
    component: MainContentComponent
  },
  {
    path: 'panelAssigning',
    component: PanelAssigningComponent
  },
  { path: "**", component: PageNotFoundComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
